export const CONSULTATION_STATUSES = {
  completed: "completed",
  in_progress: "in_progress",
  pending: "pending",
  unavailable: "unavailable",
} as const;

export type ConsultationStatus =
  (typeof CONSULTATION_STATUSES)[keyof typeof CONSULTATION_STATUSES];
